
import axios from "axios";

export const pandata = async (file) => {
    let contant = await ocr(file);
    const lines = contant.split('\n').map(line => line.trim()).filter(Boolean);
    let panNumber = '';
    let dob = '';
    let name = '';
    let fatherName = '';
    // Extract PAN number (ABCDE1234F)
    for (let line of lines) {
        const panMatch = line.match(/\b[A-Z]{5}[0-9]{4}[A-Z]\b/);
        if (panMatch) {
            panNumber = panMatch[0];
            break;
        }
    }

    // Extract DOB (DD/MM/YYYY)
    for (let line of lines) {
        const dobMatch = line.match(/\b\d{2}\/\d{2}\/\d{4}\b/);
        if (dobMatch) {
            dob = dobMatch[0];
            break;
        }
    }

    // Use DOB index to find Name and Father's Name (assuming standard layout)
    const dobIndex = lines.findIndex(line => line.includes(dob));
    if (dobIndex >= 2) {
        name = lines[dobIndex - 2];
        fatherName = lines[dobIndex - 1];
    }

    let data = {
        name: name,
        father: fatherName,
        dob: dob,
        panNumber: panNumber

    }
    return data;
}


export const adharReader = async (file) => {
    console.info('adharReaderadharReaderadharReaderadharReader', adharReader)

}

export const ocr = async (file) => {
  console.log("11file",file)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('apikey', 'K82144652588957');
    formData.append('isOverlayRequired', 'false');
    formData.append('language', 'eng');
    try {
        const res = await axios.post('https://api.ocr.space/parse/image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        const parsedText = res.data.ParsedResults?.[0]?.ParsedText || 'No text found';

    //     if (!parsedText) {
    //       window.alert("No text found");
    //       return '';
    //     }else {
    //     console.log(parsedText);
    //   }
        return parsedText;
    } catch (error) {
        console.error('OCR failed:', error);
    }

}

// export const imageReader = async (file) => {
//     const formData = new FormData();
//     formData.append("img", file, file.name);
//     try {
//       const response = await fetch("https://ai.alphamoney.in/extractFace", {
//         method: "POST",
//         body: formData,
//       });
//       if (!response.ok) {
//         console.log("dsjhdjshd")
//         const errorData = await response.json();
//         throw new Error(errorData?.message || "Extraction failed Please Reuplaod");
//       }
//       const blob = await response.blob();
//       const imageUrl = URL.createObjectURL(blob);
//       return blob;
//     } catch (error) {
//       console.log("errorerrorerror",error)
//       throw error;
//     }
// }



export const imageReader = async (fileOrUrl) => {
  let blobFile;

  // 🔍 Detect if input is a string (i.e., an image URL)
  if (typeof fileOrUrl === 'string') {
    try {
      const response = await fetch(fileOrUrl);
      if (!response.ok) throw new Error('Failed to fetch image from URL');
      blobFile = await response.blob();
    } catch (err) {
      console.error('Error fetching image from URL:', err);
      throw err;
    }
  } 
  // ✅ It's a File object (from input)
  else if (fileOrUrl instanceof File || fileOrUrl instanceof Blob) {
    blobFile = fileOrUrl;
  } else {
    throw new Error('Unsupported file type. Provide a File or URL.');
  }

  const formData = new FormData();
  formData.append("img", blobFile, "image.jpg");

  try {
    const response = await fetch("https://ai.alphamoney.in/extractFace", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Extraction failed. Please reupload.");
    }

    const extractedBlob = await response.blob();
    return extractedBlob;
  } catch (error) {
    console.error("Error in imageReader:", error);
    throw error;
  }
};




export const imageReader222 = async (file) => {
    const formData = new FormData();
    formData.append("img", file, file.name);
    try {
      const response = await fetch("https://ai.alphamoney.in/extractFace", {
        method: "POST",
        body: formData,
      });
      const blob = await response.blob();

      const imageUrl = URL.createObjectURL(blob);

      return blob;
    } catch (error) {
        return "Upload error:";
    }
}

// export const docVerifyAi = async (docs) => {
//     console.info('docc1111', docs);
 
//     try {
//       const response = await fetch("https://ai.alphamoney.in/verify", {
//         method: "POST",
//         body: docs,
//       });

//       const apiResposne_data = response.json()
//   console.log("apiResposne_data",apiResposne_data)

//       return apiResposne_data
//     } catch (error) {
//         return "ai documnent error:";
//     }
// }


export const docVerifyAi = async (docs) => {
    try {
        
      const response = await fetch("https://ai.alphamoney.in/verify", {
        method: "POST",
        body: docs,
      });
      console.log("resp",response)
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData?.message || "Verification failed");
      }
  
      const apiResponseData = await response.json();
      console.log("apiResponseData", apiResponseData);
      return apiResponseData;
    } catch (error) {
      console.error("AI Document Verification Error:", error);
      // Throw the error back to be caught in the calling function
      throw error;
    }
  };
  